const LOGISTICS_STAGE_CONFIG = {
  "NOT_STARTED": {
    label: "Not Started",
    color: "#9E9E9E",
  },
  "DESIGN & ENGINEERING": {
    label: "Design & Engineering",
    color: "#E91E63",
  },
  "PROCUREMENT": {
    label: "Procurement",
    color: "#2196F3",
  },

  "MANUFACTURING & FABRICATION": {
    label: "Manufacturing & Fabrication",
    color: "#9C27B0",
  },
  "INSTALLATION": {
    label: "Installation",
    color: "#FF9800",
  },
  "COMMISSIONING": {
    label: "Commissioning",
    color: "#4CAF50",
  },
};

export const LOGISTICS_STAGE_KEYS = [
  "NOT_STARTED",
  "DESIGN & ENGINEERING",
  "PROCUREMENT",
  "MANUFACTURING & FABRICATION",
  "INSTALLATION",
  "COMMISSIONING",
];

export function getLogisticsStageConfig(stage) {
  return LOGISTICS_STAGE_CONFIG[stage] || LOGISTICS_STAGE_CONFIG.NOT_STARTED;
}

export function getLogisticsItemKey(itemOrKey) {
  if (itemOrKey == null) return "";
  if (typeof itemOrKey !== "object") return String(itemOrKey);

  return String(
    itemOrKey.id ||
      itemOrKey.tagNumber ||
      itemOrKey.name ||
      itemOrKey.code ||
      itemOrKey.componentName ||
      itemOrKey.tierName ||
      itemOrKey.equipmentName ||
      "",
  );
}

export function getMockLogisticsStage(itemOrKey) {
  if (!itemOrKey || typeof itemOrKey !== "object") {
    return "NOT_STARTED";
  }

  const explicitStage =
    itemOrKey.logisticsStage ||
    itemOrKey.logistics_stage ||
    itemOrKey.logisticsStatus ||
    itemOrKey.logistics_status;

  return LOGISTICS_STAGE_CONFIG[explicitStage] ? explicitStage : "NOT_STARTED";
}
